import Page from '../base/Page';
import 'bootstrap3/js/tab';

/**
 * Logic for managing the Search Page.
 */
export default class SearchPage extends Page
{
    constructor() {
        super('.search-page')
    }

    init() {
        this.results = this.childElements('tbody')
        this.pagination = this.childElements('.pagination')
        this.element.on('click', '.pagination a', (event) => this.paginationLinkClick(event))
    }

    paginationLinkClick(event) {
        event.preventDefault()
        const target = $(event.target)

        $.get(target.attr('href'))
            .then(data => {
                this.pagination.html(data.Pagination)
                this.results.html(data.Results)
            }).catch(console.error);
    }
}
